import { AppMainComponent } from './../../../../app.main.component';
import { ParseHelper } from './../../parse.helper';
import { AppMainService } from '../../../../app-main.service';
import { Component, OnInit, OnDestroy, Output, EventEmitter, Input } from "@angular/core";
import { Subject, takeUntil } from "rxjs";
import { ConfirmationService, MessageService } from "primeng/api";
import { ImportService } from '../../services/import.service';
import { AccountModuleId, CMOrderModuleId, InvoiceOrderModuleId, LeadModuleId, SOModuleId, workspaceModuleId } from '../../constants/modules.constant';

interface DropdownListM { id: number; name: string; }

@Component({
    selector: "app-shared-import-field-mapping",
    styleUrls: ["./shared-import-field-mapping.component.scss"],
    templateUrl: "./shared-import-field-mapping.component.html",
})
export class SharedImportFieldMappingComponent implements OnInit, OnDestroy {

    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    @Input() displayFieldMapping: boolean = false;
    @Input() selectedModule: DropdownListM;
    @Input() selectedChannel: DropdownListM;
    @Input() sectionColumns: any[] = [];
    @Input() selectedAction: {name: string, value: string};
    @Input() selectedFile: File|null = null;
    @Input() selectedFileHeaders: {
        excelHeader: string;
        excelColumn: string;
        columnNumber: number;
        moduleField: any;
    }[] = [];
    @Input() selectedWorkspace:any;
    @Input() selectedWorkbook:any;
    @Output() dialogClosed = new EventEmitter();
    @Output() importStarted = new EventEmitter();
    selectedFileHeadersList: {
        excelHeader: string;
        excelColumn: string;
        columnNumber: number;
        moduleField: any;
    }[] = [];
    selectedFileHeadersPrev: {
        excelHeader: string;
        excelColumn: string;
        columnNumber: number;
        moduleField: any;
    }[] = [];
    dialogHeader: string = "Select Columns";
    moduleColumns: any[] = [];
    selectableFields: any[] = [];
    requiredFields: any[] = [];
    selectedTabIndex: number = 0;
    formSubmitted: boolean = false;
    displaySummary: boolean = false;

    displayTemplateFields: boolean = false;
    templateSectionColumns: any[] = [];
    contactPrimaryField: string = "contactSequenceNumber";
    addressPrimaryField: string = "addressSequenceNumber";
    contactFields: string[] = [];
    addressFields: string[] = [];

    /**Refrence Column */
    refrenceColumn: any = null;
    referenceError: string | null = null;
    workspaceModuleName: string = "Workspace";
    referenceColumnOptions: any[] = [];

    //modulesID
    accountModuleId : number = AccountModuleId;
    leadModuleId: number = LeadModuleId;
    workSpaceModuleId: number  = workspaceModuleId;

    constructor(
        private app: AppMainComponent,
        private messageService: MessageService,
        private appMainService: AppMainService,
        private importService: ImportService,
        private confirmationService: ConfirmationService
    ){}

    ngOnInit(): void {
        const addedFilteHeaders = this.selectedFileHeaders.map(fileHeader=>{
            return {
                ...fileHeader,
                moduleField: null
            }
        });
        this.selectedFileHeadersList = ParseHelper.DeepCopy(addedFilteHeaders);
        if(this.selectedModule?.name=='Tracking'){
            this.trackingFields(this.sectionColumns);
         }else{
             this.generateModuleColumnsTree(this.sectionColumns);
         }
        this.setupAutoFieldMapping();
    }

    trackingFields(moduleColumnList: any[]) {
        const selectableFields: any[] = [];
        // Filter fields based on conditions
        // const fields = moduleColumnList.filter(field =>
        //     field.enabled &&
        //     ((this.selectedAction?.value === 'add' && field.code == "sequenceNumber") || this.selectedAction?.value !== 'add')
        // );

        // Map through the filtered fields and create a new structure
        const filterDDTree = moduleColumnList.map(field => {
            const rField = {
                label: field.name,
                id: field.id,
                isSelectableField: true, // Default to false if not defined
                ...field
            };

            // Push to selectableFields if isSelectableField is true
            if (rField.isSelectableField) {
                selectableFields.push({ ...rField, children: null });
            }

            return rField;
        });

        // Deep copy of selectable fields and required fields
        this.selectableFields = ParseHelper.DeepCopy(selectableFields);
        this.requiredFields = this.selectableFields.filter(field => field.isRequired);

        // Prepare module columns with an "Unmapped" entry
        this.moduleColumns = ParseHelper.DeepCopy(filterDDTree);
        this.moduleColumns = [
            { label: 'Unmapped', id: 0 },
            ...this.moduleColumns
        ];
    }

    //#region import module selection

    generateModuleColumnsTree(moduleColumnList: any[]){
        const selectableFields: any[] = [];
        const filterDDTree = moduleColumnList.map(item => {
            const fields = item.fields
              .filter(field => (field.ischecked) && ((this.selectedAction?.value=='add' && field.field!="sequenceNumber") || this.selectedAction?.value!='add'))
              .map(field => {
                const childFields = (field?.childFields||[])
                  .filter(childField => (childField.ischecked))
                  .map(childField => {
                    const rField = {
                        label: childField.labelName,
                        parentLabelName: field?.labelName||field?.name,
                        id: childField.id,
                        isSelectableField: true,
                        ...childField,
                        children: []
                    }

                    selectableFields.push({...rField,children: null});
                    return rField;
                  });

                const rField = {
                  label: field.labelName,
                  id: field.id,
                  isSelectableField: childFields.length === 0,
                  ...field,
                  children: childFields
                };

                rField?.isSelectableField && selectableFields.push({...rField,children: null});
                return rField;
              });

            const sortedChildren = [...fields];
            sortedChildren.sort((a, b) => a.label.localeCompare(b.label));

            return {
              label: item.name,
              id: item?.id,
              isSelectableField: false,
              children: sortedChildren
            };
        });

        this.selectableFields = ParseHelper.DeepCopy(selectableFields);
        this.requiredFields = this.selectableFields.filter(field=> field.isRequired);
        this.moduleColumns = ParseHelper.DeepCopy(filterDDTree);
        this.moduleColumns = this.moduleColumns.filter(section=> section.children?.length>0);
        this.moduleColumns = [
            {label: 'Unmapped', id: 0},
            ...this.moduleColumns
        ];
        this.contactFields = this.getSectionColumns(this.contactPrimaryField);
        this.addressFields = this.getSectionColumns(this.addressPrimaryField);
    }

    getSectionColumns(fieldName: string){
        const contactSections = this.moduleColumns.find(section =>
            (section.children||[]).some(field => field.field === fieldName)
        );

        if (!contactSections?.children?.length) return [];

        return contactSections.children.flatMap(field =>
            field.children?.length ? field.children.map(child => child.field) : [field.field]
        );
    }

    setupAutoFieldMapping(){
        this.selectedFileHeaders.map(fileHeader=>{
            const fieldExist = this.selectableFields.find(field=> (field?.labelName?.trim()==fileHeader.excelHeader?.trim()) || (`${field?.labelName} *`==fileHeader.excelHeader));
            fileHeader.moduleField = fieldExist||null;
        });
        this.copyFileHeaders();
    }

    unmapAllFields() {
        this.confirmationService.confirm({
            message: 'Do you want to unmap all fields?',
            header: 'Unmap Fields Confirmation',
            icon: 'pi pi-exclamation-triangle',
            accept: () => {
                this.selectedFileHeaders.forEach(fileHeader => {
                    fileHeader.moduleField = null;
                });
                this.selectedFileHeadersPrev = ParseHelper.DeepCopy(this.selectedFileHeaders);
                this.requiredFields.forEach(field => {
                    field.fileHeader = null;
                });
                this.checkDependentFields();
            },
            reject: () => { }
        });
    }

    onRequiredFieldCahnge($event: any,field: any){
        const fileHeader = $event?.value||null;
        const moduleField = this.selectableFields.find(f=> f.field==field.field);
        const fileHeaderIndex = this.selectedFileHeaders.findIndex(f=> f.moduleField?.field==moduleField.field);

        //Remove from previous mapping
        if(fileHeaderIndex>0){
            this.selectedFileHeaders[fileHeaderIndex].moduleField = null;
        }

        if(fileHeader){
            const fileHeaderIndex = this.selectedFileHeaders.findIndex(f=> f.excelHeader==fileHeader.excelHeader);
            this.selectedFileHeaders[fileHeaderIndex].moduleField = moduleField;
        }
    }

    onFieldChange($event: any, field: any){
        if($event?.node?.id==0){
            setTimeout(()=>{
                field.moduleField = null;
                this.copyFileHeaders();
            });
        }else{
            const alreadyMapped = this.selectedFileHeadersPrev.find(fileHeader=> fileHeader.moduleField==$event?.node?.field);

            if(alreadyMapped){
                this.confirmationService.confirm({
                    message: `This field already mapped with ${alreadyMapped.excelHeader} column, Do you want to map with current column?`,
                    header: 'Field Already Mapped',
                    icon: 'pi pi-info-circle',
                    accept: () => {
                        const findIndex = this.selectedFileHeaders.findIndex(fileHeader=> fileHeader.excelHeader==alreadyMapped.excelHeader);
                        if(findIndex>=0){
                            this.selectedFileHeaders[findIndex].moduleField = null;
                        }
                        this.copyFileHeaders();
                    },
                    reject: () => {
                        const moduleField = this.selectableFields.find(field=> field.field==alreadyMapped?.moduleField);
                        field.moduleField = moduleField||null;
                        this.copyFileHeaders();
                    }
                });
            }else{
                this.copyFileHeaders();
            }
        }
    }

    copyFileHeaders(){
        setTimeout(()=>{
            this.checkDependentFields();
            const addedFilteHeaders = this.selectedFileHeaders.map(fileHeader=>{
                const fieldExist = this.selectableFields.find(field=> (field?.field==fileHeader?.moduleField?.field));
                return {
                    ...fileHeader,
                    moduleField: fieldExist ? fieldExist.field : null
                }
            })
            this.selectedFileHeadersPrev = ParseHelper.DeepCopy(addedFilteHeaders);
            this.requiredFields.map(field=>{
                const addedFileHeader = this.selectedFileHeaders.find(fileHeader=> fileHeader.moduleField?.field==field.field);
                field.fileHeader = addedFileHeader ? {...addedFileHeader,moduleField: null} : null;
            })
        });
    }

    checkDependentFields(){
        if(this.selectedAction?.value !== 'add'){
            //Make Contact ID Reqired if Contact Field Selected for Update
            const contactFields = this.selectedFileHeaders.filter(fileHeader=> this.contactFields.includes(fileHeader.moduleField?.field));
            const contactPrimaryIndex = this.requiredFields.findIndex(field=> field.field==this.contactPrimaryField);
            if(contactFields?.length>0 && contactPrimaryIndex<0){
                const contactPrimaryField = this.selectableFields.find(field=> (field?.field==this.contactPrimaryField));
                this.requiredFields.push(contactPrimaryField);
            }
            if(contactFields?.length==0 && contactPrimaryIndex>=0){
                this.requiredFields.splice(contactPrimaryIndex,1);
            }

            //Make Address Type Reqired if Address Field Selected for Update
            const addressFields = this.selectedFileHeaders.filter(fileHeader=> this.addressFields.includes(fileHeader.moduleField?.field));
            const addressPrimaryIndex = this.requiredFields.findIndex(field=> field.field==this.addressPrimaryField);
            if(addressFields?.length>0 && addressPrimaryIndex<0){
                const addressPrimaryField = this.selectableFields.find(field=> (field?.field==this.addressPrimaryField));
                this.requiredFields.push(addressPrimaryField);
            }
            if(addressFields?.length==0 && addressPrimaryIndex>=0){
                this.requiredFields.splice(addressPrimaryIndex,1);
            }
        }
    }

    importData() {
        if ([this.accountModuleId, this.leadModuleId, this.workSpaceModuleId].includes(this.selectedModule?.id) && this.selectedAction?.value !== 'add') {
            this.validateReferenceColumn(this.refrenceColumn);
        }
        // Prevent form submission if there's a validation error
        if (this.referenceError) {
            return;
        }

        // ** Header Change in xlsx file end
        const date = new Date().toISOString();
        const mappingFields = this.selectedFileHeaders.filter(fileHeader=> fileHeader.moduleField).map(fileHeader=>{
            if(this.selectedModule?.id === workspaceModuleId){
                return {
                    fileHeader: fileHeader.excelHeader,
                    labelName: fileHeader.moduleField.labelName,
                    field: fileHeader.moduleField.field,
                    columnNumber: fileHeader.columnNumber,
                    custom: fileHeader.moduleField.custom,
                    formControlId: fileHeader.moduleField.formControlId,
                    IsRequired: fileHeader.moduleField.isRequired,
                    refrenceColumnId: fileHeader.moduleField.id,
                    formControlName: fileHeader.moduleField.formControl
                }
            }
            else{
                return {
                    fileHeader: fileHeader.excelHeader,
                    labelName: fileHeader.moduleField.labelName,
                    field: fileHeader.moduleField.field,
                    columnNumber: fileHeader.columnNumber,
                    custom: fileHeader.moduleField.custom,
                    formControlId: fileHeader.moduleField.id,
                    IsRequired: fileHeader.moduleField.isRequired
                }
            }
        });

        const fileId = 1;
        let channelId = this.selectedChannel?.id;
        switch(this.selectedModule?.id){
            case SOModuleId:
                channelId = 3;
                break;
            case InvoiceOrderModuleId:
                channelId = 4;
                break;
            case CMOrderModuleId:
                channelId = 6;
                break;
            case workspaceModuleId:
                channelId = 0;
                break;
        }

        let payLoad = {
            id: 0,
            importSchedular: {
                importFileId: 1,
                lastRunTime: date,
                statusId: 1,
                endRunTime: date,
                id: 0,
                createdSource: this.app.userIP,
                startRunTime: date,
                updatedSource: "",
                createdBy: this.app.user.userId,
                runTime: date,
                updatedBy: "",
                createdDate: date,
                updatedDate: date,
            },
            lastRunTime: new Date().toISOString(),
            organizationId: this.app.user.organizationId,
            fileSize: 0,
            failedRows: 0,
            totalRows: 0,
            importStatusId: 49,
            statusId: 1,
            mappingFields: JSON.stringify(mappingFields),
            objectName: this.selectedModule?.name,
            objectId: this.selectedModule?.id,
            filePath: "",
            displayFileName: "",
            fileName: "",
            file: this.selectedFile,
            channelId: channelId,
            actionType: this.selectedAction?.value || null,
            importId: "",
            importedByName: "",
            createdSource: this.app.userIP,
            updatedSource: "",
            createdBy: this.app.user.userId,
            updatedBy: this.app.user.userId,
            createdDate: new Date().toISOString(),
            updatedDate: new Date().toISOString(),
            WorkspaceId: this.selectedWorkspace?.id || "",
            WorkbookId: this.selectedWorkbook?.id || "",
            WorkspaceName: this.selectedWorkspace?.name || "",
            WorkbookName: this.selectedWorkbook?.name || "",
            ReferenceColumn: this.refrenceColumn?.field || "",
            ReferenceColumnId : this.refrenceColumn?.id || "",
        };

        var data = this.convertToFormData(payLoad);

        this.appMainService.isShowSpinner("addImportFile");

        this.importService.importFile(data).pipe(takeUntil(this.ngUnsubscribe$)).subscribe({
            next: (response)=>{
                this.appMainService.isHideSpinner("addImportFile");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "File has uploaded successfully...",
                });
                this.displaySummary = false;
                this.importStarted.emit();
                this.closeDialog();
            },
            error: (error)=>{
                this.appMainService.isHideSpinner("addImportFile");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: error?.error?.Message||'Failed to import data, please try again.'
                });
            }
        })
    }

    saveTrackingMappedData(){
        if (this.selectedAction?.value == 'update') {
            this.validateReferenceColumn(this.refrenceColumn);
        }
        // Prevent form submission if there's a validation error
        if (this.referenceError) {
            return;
        }
        const mappingFields = this.selectedFileHeaders.filter(fileHeader=> fileHeader.moduleField).map(fileHeader=>{
            return {
                fileHeader: fileHeader.excelHeader,
                labelName: fileHeader.moduleField.labelName,
                field: fileHeader.moduleField.field,
                columnNumber: fileHeader.columnNumber,
                custom: fileHeader.moduleField.custom,
                formControlId: fileHeader.moduleField.id,
                IsRequired: fileHeader.moduleField.isRequired
            }
        });
        this.displaySummary = false;
        const obj = {
            referenceId: this.refrenceColumn,
            mappedData: mappingFields
        }
        this.importStarted.emit(obj);
        this.closeDialog();
    }

    convertToFormData(obj) {
        let _formData = new FormData();

        let keys = Object.keys(obj);

        keys?.forEach((element) => {
            if (element === 'importSchedular') {
                for (let value in obj[element]) {
                    _formData.append(`importSchedular.${value}`, obj[element][value])
                }
            }
            else {
                if (element == "file") {
                    obj[element] &&
                        obj[element].name &&
                        _formData.append("file", obj[element], obj[element].name);
                } else {
                    _formData.append(element, obj[element]);
                }
            }

        });

        return _formData;
    }

    //#endregion

    get mappedFieldsCount() {
        return this.selectedFileHeaders.filter(fileHeader=> fileHeader.moduleField)?.length;
    }

    get unMappedFieldsCount() {
        return this.selectedFileHeaders.filter(fileHeader=> !fileHeader.moduleField)?.length;
    }

    get unMappedRequiredFields() {
        return this.requiredFields.filter(field=> !field.fileHeader)?.length;
    }

    applyAutoMapping(){
        this.confirmationService.confirm({
            message: 'Do you want to auto map the fields?',
            header: 'Auto Mapping Confirmation',
            icon: 'pi pi-info-circle',
            accept: () => {
                this.setupAutoFieldMapping();
            },
            reject: () => { }
        });
    }

    loadTemplateFields(){
        this.templateSectionColumns = ParseHelper.DeepCopy(this.sectionColumns);
        this.displayTemplateFields = true;
    }

    templateFieldsRefresh(sectionColumns: any){
        this.sectionColumns = ParseHelper.DeepCopy(sectionColumns);
        this.generateModuleColumnsTree(this.sectionColumns);

        this.selectedFileHeaders.map(fileHeader=>{
            const checkField = this.selectableFields.find(field=> field.field==fileHeader?.moduleField?.field);
            if(fileHeader?.moduleField?.field && !checkField){
                fileHeader.moduleField = null;
            }
        });
        const addedFilteHeaders = this.selectedFileHeaders.map(fileHeader=>{
            return {
                ...fileHeader,
                moduleField: null
            }
        });
        this.selectedFileHeadersList = ParseHelper.DeepCopy(addedFilteHeaders);
        this.copyFileHeaders();
        this.closeTemplateFields();
    }

    closeTemplateFields(){
        this.displayTemplateFields = false;
    }

    closeDialog(){
        this.displayFieldMapping = false;
        this.dialogClosed.emit(true);
    }

    viewSummery(){
        this.formSubmitted = true;
        if (([this.accountModuleId, this.leadModuleId, this.workSpaceModuleId].includes(this.selectedModule?.id) || this.selectedModule?.name=='Tracking') && this.selectedAction?.value !== 'add') {
            this.referenceColumnOptions = this.selectedFileHeaders
            .filter(fileHeader => fileHeader.moduleField !== null)
            .map(fileHeader => fileHeader.moduleField);
        if (this.referenceColumnOptions?.length < 2) {
            this.messageService.add({
                severity: "error",
                summary: "Selection Error",
                detail: "Please select at least two columns before proceeding.",
            });
            return;
        }

        if ([this.accountModuleId,this.leadModuleId].includes(this.selectedModule?.id)) {
            this.referenceColumnOptions = this.referenceColumnOptions.filter(
                field => !this.contactFields.includes(field.field) && !this.addressFields.includes(field.field)
            );
            if (this.referenceColumnOptions?.length < 1) {
                this.messageService.add({
                    severity: "error",
                    summary: "Selection Error",
                    detail: "Please select at least one reference column before proceeding.",
                });
                return;
            }
        }

    }

        if(this.unMappedRequiredFields>0){
            this.selectedTabIndex = 3;
            return;
        }

        if(this.unMappedFieldsCount>0){
            this.confirmationService.confirm({
                message: 'Some columns are not mapped. Do you still want to continue?',
                header: 'Unmapped Columns',
                icon: 'pi pi-info-circle',
                accept: () => {
                    this.displaySummary = true;
                },
                reject: () => {
                    this.selectedTabIndex = 2;
                 }
            });
        }else{
            this.displaySummary = true;
        }
    }

    closeSummeryDialog(){
        this.displaySummary = false;
    }

    validateReferenceColumn(selectedColumn: any) {
        if (!selectedColumn) {
            this.referenceError = "Reference Column is required!";
            return;
        }

        const columnName = selectedColumn.field;
        const isValid = this.selectedFileHeaders.some(header => header.moduleField?.field === columnName);

        this.referenceError = isValid ? null : "Selected Reference Column is not valid!";
    }

    ngOnDestroy(): void {
        if (this.ngUnsubscribe$) {
            this.ngUnsubscribe$.next();
            this.ngUnsubscribe$.complete();
            this.ngUnsubscribe$.unsubscribe();
        }
    }
}
